<!-- Spacer -->
<div
    class="core-vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
